var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46867 1.4591C7.63069 1.34409 5.81395 1.90399 4.35958 3.03368C2.90521 4.16336 1.91326 5.78512 1.57 7.59442C1.22747 9.39986 1.55437 11.2681 2.48933 12.8498C2.58825 13.0104 2.61956 13.2091 2.56515 13.3995L1.75103 16.2489L1.17237 16.0836L1.75104 16.2489L4.60043 15.4348C4.78801 15.3812 4.98712 15.4103 5.14965 15.5103C6.73147 16.4455 8.59994 16.7725 10.4056 16.43C12.2149 16.0867 13.8366 15.0947 14.9663 13.6404C16.096 12.186 16.6559 10.3692 16.5408 8.53125C16.4258 6.69328 15.6438 4.96051 14.3416 3.65833C13.0394 2.35614 11.3066 1.57412 9.46867 1.4591ZM4.69992 16.8364C6.51466 17.8319 8.62218 18.1678 10.6619 17.7809C12.8003 17.3751 14.717 16.2027 16.0522 14.4838C17.3874 12.7649 18.0491 10.6177 17.9132 8.44537C17.7772 6.27306 16.8529 4.22511 15.3139 2.68605C13.7748 1.147 11.7268 0.222725 9.55454 0.0867877C7.38224 -0.0491493 5.23502 0.612602 3.5161 1.94778C1.79718 3.28296 0.624793 5.19971 0.219093 7.33812C-0.167876 9.3778 0.168067 11.4853 1.16355 13.3L0.428938 15.8712C0.361573 16.1069 0.358483 16.3564 0.419992 16.5938C0.4815 16.8312 0.605368 17.0478 0.77876 17.2212C0.952154 17.3946 1.16876 17.5184 1.40613 17.58C1.6435 17.6415 1.893 17.6384 2.12878 17.571L4.69992 16.8364Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.357c33b4.svg";
export { ForwardRef as ReactComponent };